var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Command from '../Command';
import getTransmissionModes from '../../requests/referenceData/getTransmissionModes';
var GetTransmissionModesCommand = /** @class */ (function (_super) {
    __extends(GetTransmissionModesCommand, _super);
    function GetTransmissionModesCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @param collection TransmissionModeCollection
     * @return {Promise<any>}
     */
    GetTransmissionModesCommand.prototype.execute = function (collection) {
        this.collection = collection;
        if (this.collection.fetching) {
            return this.collection.fetching;
        }
        else {
            this.collection.fetching = getTransmissionModes(!this.collection.firstFetchComplete)
                .then(this.then)
                .catch(this.catch);
            return this.collection.fetching;
        }
    };
    GetTransmissionModesCommand.prototype.then = function (response) {
        this.collection.fetching = null;
        this.collection.reset(false);
        this.collection.addAll(response);
        this.collection.firstFetchComplete = true;
    };
    GetTransmissionModesCommand.prototype.catch = function (error) {
        this.collection.fetching = null;
        throw error;
    };
    return GetTransmissionModesCommand;
}(Command));
export default GetTransmissionModesCommand;
